import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import BkInformationChip from '../../../../../components/chip/BkInformationChip';
import { BkErrorChip } from '../../../../../components/chip/BkErrorChip';
import { CASE_DOCKET, CaseDocketEntry, USER_SUPPLIED } from '../../../../../utils/constant';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

const DocumentsPageTotalPages = () => {
  const totalUploadedPdfsPageSize = useSelector((state: RootState) => state.upload.totalUploadedPdfsPageSize);

  const uploadedPdfs = useSelector((state: RootState) => state.upload.formData.uploadedPdfs);

  const uploadedBallot = useSelector((state: RootState) => state.upload.formData.uploadedBallot);

  const uploadedProofOfClaim = useSelector((state: RootState) => state.upload.formData.uploadedProofOfClaim);

  const caseDocketEntries = useSelector((state: RootState) => state.upload.formData.caseDocketEntries);

  const caseSource = useSelector((state: RootState) => state.upload.formData.caseSource);

  const errors = useSelector((state: RootState) => state.upload.errors);

  const totalFilesUploaded = uploadedPdfs.length + uploadedBallot.length + uploadedProofOfClaim.length;

  const renderDocumentsTitle = () => {
    if (totalFilesUploaded === 0) {
      return '0 Files';
    }

    if (totalFilesUploaded > 1) {
      return `${totalFilesUploaded} Files · ${totalUploadedPdfsPageSize} Total Pages`;
    } else {
      return `1 File · ${totalUploadedPdfsPageSize} Total Pages`;
    }
  };

  const getChipBackgroundColor = () => {
    if (totalFilesUploaded === 0) {
      return '#e5e4e5';
    } else {
      return '#E8FCF1';
    }
  };

  const calculateTotalCaseDocketPages = (arr: CaseDocketEntry[]) => {
    let totalPagesSize = 0;
    arr.map((item) => {
      totalPagesSize = totalPagesSize + Number(item.pageCount);
    });

    return totalPagesSize;
  };

  const renderCaseDocketFilesTitle = () => {
    const selectedDocuments = caseDocketEntries.filter((item) => item.isChecked);

    if (selectedDocuments.length === 0) {
      return '0 files selected';
    }

    if (selectedDocuments.length > 1) {
      return `${selectedDocuments.length} files chosen, ${calculateTotalCaseDocketPages(selectedDocuments)} pages total`;
    } else {
      return `1 file chosen, ${calculateTotalCaseDocketPages(selectedDocuments)} pages total`;
    }
  };

  const renderInformationBasedOnDocketSource = () => {
    return (
      <BkInformationChip
        backgroundColor={getChipBackgroundColor()}
        icon={<TextSnippetIcon />}
        label={renderDocumentsTitle()}
      />
    );
  };

  return <div style={{ marginLeft: '3rem' }}>{renderInformationBasedOnDocketSource()}</div>;
};

export default DocumentsPageTotalPages;
